import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LeaveTable from "./Approve_LeaveTable";
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";

const Approve_LeavePage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmallMobile = useMediaQuery("(max-width:420px)");

  const { permissions } = useSelector((state) => state.globalVariables);

  const REQUIRED_PERMISSION = 87;
  const hasPermission = permissions?.includes(REQUIRED_PERMISSION);

  const [ischange, setIschange] = useState(false);

  // ── Permission guard ──
  if (!hasPermission) {
    return (
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Box
          sx={{
            background: "#fff",
            borderRadius: "12px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            padding: { xs: "32px 24px", md: "40px 48px" },
            maxWidth: "560px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "24px",
              flexWrap: "wrap",
              mb: 3.5,
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  fontSize: { xs: "52px", md: "64px" },
                  fontWeight: 800,
                  lineHeight: 1,
                  color: "#f0576b",
                }}
              >
                403
              </Typography>
              <Typography
                sx={{
                  fontSize: "26px",
                  fontWeight: 700,
                  color: "#f5a623",
                  mt: "6px",
                  mb: "14px",
                }}
              >
                Forbidden
              </Typography>
              <Typography
                sx={{
                  color: "#f0576b",
                  fontSize: "13px",
                  lineHeight: 1.5,
                }}
              >
                Sorry, you're not allowed in here
                <br />
                Please contact IT
              </Typography>
            </Box>
            <svg width="150" height="150" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.9">
                <circle cx="150" cy="42" r="20" fill="#e9e9e9" stroke="#cfcfcf" strokeWidth="1.5" />
                <path d="M130 42h40M150 22v40M136 28l28 28M164 28l-28 28" stroke="#cfcfcf" strokeWidth="1" />
                <path d="M120 20l3 6 6 1-4.5 4.5 1 6-5.5-3-5.5 3 1-6L112 26l6-1z" fill="#ffd166" />
                <path d="M178 60l2 4 4 1-3 3 .5 4-3.5-2-3.5 2 .5-4-3-3 4-1z" fill="#ffd166" />
              </g>
              <ellipse cx="90" cy="150" rx="34" ry="6" fill="#000" opacity="0.06" />
              <rect x="70" y="86" width="12" height="66" rx="5" fill="#111" />
              <rect x="108" y="86" width="12" height="66" rx="5" fill="#111" />
              <rect x="55" y="90" width="80" height="66" rx="16" fill="#1a1a1a" />
              <rect x="80" y="96" width="30" height="44" rx="10" fill="#262626" />
              <circle cx="90" cy="60" r="22" fill="#e0ac69" />
              <path d="M68 58a22 22 0 0 1 44 0v-4a22 22 0 0 0-44 0z" fill="#3b2a20" />
              <rect x="72" y="56" width="36" height="10" rx="5" fill="#111" />
              <circle cx="35" cy="86" r="6" fill="#111" />
              <circle cx="45" cy="150" r="6" fill="#111" />
              <path d="M35 86c-4 20 5 45 10 64" stroke="#d4a24c" strokeWidth="2.5" fill="none" />
              <path d="M45 150c40 10 90 10 130 0" stroke="#c8102e" strokeWidth="4" fill="none" />
              <circle cx="175" cy="150" r="6" fill="#111" />
            </svg>
          </Box>

          <Typography variant="h5" fontWeight="bold" sx={{ color: "#333", mb: 1 }}>
            403 - Not Authorized
          </Typography>

          <Typography variant="body1" sx={{ color: "#777" }}>
            You do not have permission to access this page.
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate("/dashboard/dashboard")}
            sx={{ mt: 3, px: 4, py: 1, textTransform: "none", fontWeight: 600 }}
          >
            Go to Home
          </Button>
        </Box>
      </Box>
    );
  }

  const rootPadding = isSmallMobile ? 1 : isMobile ? 1.5 : 3;

  return (
    <Box
      sx={{
        p: rootPadding,
        width: "100%",
        maxWidth: "100%",
        minHeight: "100vh",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 3 }}>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{
            color: "#1976d2",
            fontSize: isSmallMobile ? "1.1rem" : isMobile ? "1.25rem" : "1.5rem",
          }}
        >
          Leave Management
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          "& .MuiTableContainer-root": {
            overflowX: "auto",
            maxWidth: "100%",
          },
          "& table": {
            minWidth: isMobile ? 600 : 700,
          },
        }}
      >
        <LeaveTable ischange={ischange} />
      </Box>
    </Box>
  );
};

export default Approve_LeavePage;